import "./ExcalidrawLogo.scss";

// pro100доска: text-only wordmark, no icon mark next to it (dropped by
// explicit request — see design-system.md). LogoIcon (hand-drawn "EXCALIDRAW"
// SVG path) removed along with it, since a wordmark of a different name
// makes no sense drawn with someone else's hand-lettering — this is now a
// plain text node styled in Nunito instead.
const LogoText = () => (
  <span className="ExcalidrawLogo-text">pro100доска</span>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      {withText && <LogoText />}
    </div>
  );
};
